import React from "react";
import { proofBar } from "../mock/mock";

const Metrics = () => {
  return (
    <section className="relative py-16 lg:py-20 bg-ink text-ivory-50 overflow-hidden grain-overlay">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="flex items-center gap-3 mb-10">
          <span className="h-px w-10 bg-bronze" />
          <span className="text-[11px] uppercase tracking-[0.3em] text-ivory-50/70">
            Proof · 15 years, three markets
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {proofBar.map((m, i) => (
            <div key={i} className="group">
              <div className="font-serif-display text-4xl lg:text-[44px] text-ivory-50 font-light group-hover:text-bronze transition-colors leading-none">
                {m.value}
              </div>
              <div className="mt-3 h-px w-8 bg-bronze" />
              <div className="mt-3 text-[13px] text-ivory-50/85 leading-snug">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Metrics;
